// R2 signs an exact header set - a PUT that omits one 403s. Older API responses omit the field.
export const presignHeaders = (data, fallbackContentType) =>
  data?.requiredHeaders || data?.required_headers || { 'Content-Type': fallbackContentType };
